'use client'

import { useEffect } from 'react'
import { I18nextProvider } from 'react-i18next'

import i18n from './config'

interface Props {
  children: React.ReactNode
  locale: string
}

export function I18nProvider({ children, locale }: Props) {
  useEffect(() => {
    if (i18n.language !== locale) {
      i18n.changeLanguage(locale)
    }
    document.documentElement.lang = locale
  }, [locale])

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>
}
